export default __webpack_public_path__ + "static/media/freeplanIndicationIcon.8e5368a5.svg";